import axios from 'axios'
import {
    getRequestIP
} from './server'
let timeout = 60000;
export const token = 'SamexSysCom'
export const postRequest = (action, params) => {
    return axios({
        method: 'post',
        url: getRequestIP(action),
        data: params,
        timeout: timeout,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
}
export const putRequest = (action, params) => {
    return axios({
        method: 'put',
        url: getRequestIP(action),
        data: params,
        timeout: timeout,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
}
export const deleteRequest = (action, params) => {
    return axios({
        method: 'delete',
        url: getRequestIP(action),
        data: params,
        timeout: timeout,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
    });
}
export const getResuest = (action, params) => {
    return axios({
        method: 'get',
        url: getRequestIP(action),
        data: params,
        timeout: timeout,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
    });
}